module.exports = __webpack_public_path__ + "build/img/2.f32070cc.png";